const SET_INITIAL_USER_INFO = "SET_INITIAL_USER_INFO";
const SET_PUBLIC_KEY = "SET_PUBLIC_KEY";
const SET_SELECTED_LANGUAGE = "SET_SELECTED_LANGUAGE";
const SET_MANAGER_EMAIL = "SET_MANAGER_EMAIL";
const SET_MANAGER_EMAIL_REQUIRED = "SET_MANAGER_EMAIL_REQUIRED";
const SET_USER_AUTHENTICATED = "SET_USER_AUTHENTICATED";
const SET_USER_AUTHENTICATION_START = "SET_USER_AUTHENTICATION_START";
const SET_USER_AUTHENTICATION_FAIL_REASON = "SET_USER_AUTHENTICATION_FAIL_REASON";

const GET_PEOPLE_INFO = "GET_PEOPLE_INFO";
const GET_PEOPLE_INFO_SUCCESS = "GET_PEOPLE_INFO_SUCCESS";
const GET_PEOPLE_INFO_FAILURE = "GET_PEOPLE_INFO_FAILURE";

const GET_LEARNER_TASKS = "GET_LEARNER_TASKS";
const GET_LEARNER_TASKS_SUCCESS = "GET_LEARNER_TASKS_SUCCESS";
const GET_LEARNER_TASKS_FAILURE = "GET_LEARNER_TASKS_FAILURE";

const GET_PORTAL_LOGIN = "GET_PORTAL_LOGIN";
const GET_PORTAL_LOGIN_SUCCESS = "GET_PORTAL_LOGIN_SUCCESS";
const GET_PORTAL_LOGIN_FAILURE = "GET_PORTAL_LOGIN_FAILURE";

const GET_LEARNER_JWTOKEN = "GET_LEARNER_JWTOKEN";
const GET_LEARNER_JWTOKEN_SUCCESS = "GET_LEARNER_JWTOKEN_SUCCESS";
const GET_LEARNER_JWTOKEN_FAILURE = "GET_LEARNER_JWTOKEN_FAILURE";

const GET_NEWSFEED_API = "GET_NEWSFEED_API";
const GET_NEWSFEED_API_SUCCESS = "GET_NEWSFEED_API_SUCCESS";
const GET_NEWSFEED_API_FAILURE = "GET_NEWSFEED_API_FAILURE";

const GET_WELCOMEFLOW_API = "GET_WELCOMEFLOW_API";
const GET_WELCOMEFLOW_API_SUCCESS = "GET_WELCOMEFLOW_API_SUCCESS";
const GET_WELCOMEFLOW_API_FAILURE = "GET_WELCOMEFLOW_API_FAILURE";

const GET_TMS_COURSES = "GET_TMS_COURSES";
const GET_TMS_COURSES_SUCCESS = "GET_TMS_COURSES_SUCCESS";
const GET_TMS_COURSES_FAILURE = "GET_TMS_COURSES_FAILURE";

const GET_ELEVATE_ASSESSMENT_DETAILS = "GET_ELEVATE_ASSESSMENT_DETAILS";
const GET_ELEVATE_ASSESSMENT_DETAILS_SUCCESS = "GET_ELEVATE_ASSESSMENT_DETAILS_SUCCESS";
const GET_ELEVATE_ASSESSMENT_DETAILS_FAILURE = "GET_ELEVATE_ASSESSMENT_DETAILS_FAILURE";

const GET_ELEVATE_TEST_RESULT = "GET_ELEVATE_TEST_RESULT";
const GET_ELEVATE_TEST_RESULT_SUCCESS = "GET_ELEVATE_TEST_RESULT_SUCCESS";
const GET_ELEVATE_TEST_RESULT_FAILURE = "GET_ELEVATE_TEST_RESULT_FAILURE";

const GET_TMS_LOGIN = "GET_TMS_LOGIN";
const GET_TMS_LOGIN_SUCCESS = "GET_TMS_LOGIN_SUCCESS";
const GET_TMS_LOGIN_FAILURE = "GET_TMS_LOGIN_FAILURE";

const GET_TMS_LOGOUT = "GET_TMS_LOGOUT";
const GET_TMS_LOGOUT_SUCCESS = "GET_TMS_LOGOUT_SUCCESS";
const GET_TMS_LOGOUT_FAILURE = "GET_TMS_LOGOUT_FAILURE";

const STOP_TMS_API_PROPAGATION = "STOP_TMS_API_PROPAGATION";

const GET_ANNOUNCEMENTS = "GET_ANNOUNCEMENTS";
const GET_ANNOUNCEMENTS_SUCCESS = "GET_ANNOUNCEMENTS_SUCCESS";
const GET_ANNOUNCEMENTS_FAILURE = "GET_ANNOUNCEMENTS_FAILURE";

const GET_JWK_PUBLIC_KEY = "GET_JWK_PUBLIC_KEY";
const GET_JWK_PUBLIC_KEY_SUCCESS = "GET_JWK_PUBLIC_KEY_SUCCESS";
const GET_JWK_PUBLIC_KEY_FAILURE = "GET_JWK_PUBLIC_KEY_FAILURE";

const DESTROY_SESSION = "DESTROY_SESSION";
const TRIGGER_TOAST = "TRIGGER_TOAST";
const RESET_TOAST = "RESET_TOAST";

const GET_RENEWAL_INFO = "GET_RENEWAL_INFO";
const GET_RENEWAL_INFO_SUCCESS = "GET_RENEWAL_INFO_SUCCESS";
const GET_RENEWAL_INFO_FAILURE = "GET_RENEWAL_INFO_FAILURE";

const GET_ACTIVE_COURSE_INFO = "GET_ACTIVE_COURSE_INFO";
const GET_ACTIVE_COURSE_SUCCESS = "GET_ACTIVE_COURSE_SUCCESS";
const GET_ACTIVE_COURSE_FAILURE = "GET_ACTIVE_COURSE_FAILURE";

const GET_TMS_ASSIGNMENTS_INFO = "GET_TMS_ASSIGNMENTS_INFO";
const GET_TMS_ASSISGNMENTS_SUCCESS = "GET_TMS_ASSISGNMENTS_SUCCESS";
const GET_TMS_ASSISGNMENTS_FAILURE = "GET_TMS_ASSISGNMENTS_FAILURE";

const GET_HANDOUTS_INFO = "GET_HANDOUTS_INFO";
const GET_HANDOUTS_SUCCESS = "GET_HANDOUTS_SUCCESS";
const GET_HANDOUTS_FAILURE = "GET_HANDOUTS_FAILURE";

const GET_HOMEWORKS_INFO = "GET_HOMEWORKS_INFO";
const GET_HOMEWORKS_SUCCESS = "GET_HOMEWORKS_SUCCESS";
const GET_HOMEWORKS_FAILURE = "GET_HOMEWORKS_FAILURE";

const GET_TMS_LEARNER_SESSION_INFO = "GET_TMS_LEARNER_SESSION_INFO";
const GET_TMS_LEARNER_SESSION_SUCCESS = "GET_TMS_LEARNER_SESSION_SUCCESS";
const GET_TMS_LEARNER_SESSION_FAILURE = "GET_TMS_LEARNER_SESSION_FAILURE";

const GET_CITIES_LIST = "GET_CITIES_LIST";
const GET_CITIES_LIST_SUCCESS = "GET_CITIES_LIST_SUCCESS";
const GET_CITIES_LIST_FAILURE = "GET_CITIES_LIST_FAILURE";

const GET_COUNTRIES_LIST = "GET_COUNTRIES_LIST";
const GET_COUNTRIES_LIST_SUCCESS = "GET_COUNTRIES_LIST_SUCCESS";
const GET_COUNTRIES_LIST_FAILURE = "GET_COUNTRIES_LIST_FAILURE";

const GET_STATES_LIST = "GET_STATES_LIST";
const GET_STATES_LIST_SUCCESS = "GET_STATES_LIST_SUCCESS";
const GET_STATES_LIST_FAILURE = "GET_STATES_LIST_FAILURE";

const GET_CUSTOM_FIELDS = "GET_CUSTOM_FIELDS";
const GET_CUSTOM_FIELDS_SUCCESS = "GET_CUSTOM_FIELDS_SUCCESS";
const GET_CUSTOM_FIELDS_FAILURE = "GET_CUSTOM_FIELDS_FAILURE";

const SET_CUSTOM_FIELDS = "SET_CUSTOM_FIELDS";
const SET_CUSTOM_FIELDS_SUCCESS = "SET_CUSTOM_FIELDS_SUCCESS";
const SET_CUSTOM_FIELDS_FAILURE = "SET_CUSTOM_FIELDS_FAILURE";

const SEND_OTP = "SEND_OTP";
const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
const SEND_OTP_FAILURE = "SEND_OTP_FAILURE";

const UPDATE_TIMEZONE = "UPDATE_TIMEZONE";
const UPDATE_TIMEZONE_SUCCESS = "UPDATE_TIMEZONE_SUCCESS";
const UPDATE_TIMEZONE_FAILURE = "UPDATE_TIMEZONE_FAILURE";
const RESET_TIMEZONE_STATE = "RESET_TIMEZONE_STATE";

const SET_PEOPLE_INFO = "SET_PEOPLE_INFO";
const SET_PEOPLE_INFO_SUCCESS = "SET_PEOPLE_INFO_SUCCESS";
const SET_PEOPLE_INFO_FAILURE = "SET_PEOPLE_INFO_FAILURE";
const SET_PEOPLE_INFO_RESET = "SET_PEOPLE_INFO_RESET";

const SET_LEARNER_TASKS = "SET_LEARNER_TASKS";
const SET_LEARNER_TASKS_SUCCESS = "SET_LEARNER_TASKS_SUCCESS";
const SET_LEARNER_TASKS_FAILURE = "SET_LEARNER_TASKS_FAILURE";

const UPDATE_LEARNER_TASKS = "UPDATE_LEARNER_TASKS";
const UPDATE_LEARNER_TASKS_SUCCESS = "UPDATE_LEARNER_TASKS_SUCCESS";
const UPDATE_LEARNER_TASKS_FAILURE = "UPDATE_LEARNER_TASKS_FAILURE";
const CLEAR_INTERMEDIATE_LEARNER_TASKS = "CLEAR_INTERMEDIATE_LEARNER_TASKS";

const UPDATE_PASSWORD_PEOPLE = "UPDATE_PASSWORD_PEOPLE";
const UPDATE_PASSWORD_PEOPLE_SUCCESS = "UPDATE_PASSWORD_PEOPLE_SUCCESS";
const UPDATE_PASSWORD_PEOPLE_FAILURE = "UPDATE_PASSWORD_PEOPLE_FAILURE";

const UPDATE_NEW_PASSWORD_PEOPLE = "UPDATE_NEW_PASSWORD_PEOPLE";
const UPDATE_NEW_PASSWORD_PEOPLE_SUCCESS = "UPDATE_NEW_PASSWORD_PEOPLE_SUCCESS";
const UPDATE_NEW_PASSWORD_PEOPLE_FAILURE = "UPDATE_NEW_PASSWORD_PEOPLE_FAILURE";

const GET_SKILLS_PROGRESS = "GET_SKILLS_PROGRESS";
const GET_SKILLS_PROGRESS_SUCCESS = "GET_SKILLS_PROGRESS_SUCCESS";
const GET_SKILLS_PROGRESS_FAILURE = "GET_SKILLS_PROGRESS_FAILURE";

const GET_REACH_PROGRESS = "GET_REACH_PROGRESS";
const GET_REACH_PROGRESS_SUCCESS = "GET_REACH_PROGRESS_SUCCESS";
const GET_REACH_PROGRESS_FAILURE = "GET_REACH_PROGRESS_FAILURE";

const GET_ELEVATE_LEVEL_PROGRESS = "GET_ELEVATE_LEVEL_PROGRESS";
const GET_ELEVATE_LEVEL_PROGRESS_SUCCESS = "GET_ELEVATE_LEVEL_PROGRESS_SUCCESS";
const GET_ELEVATE_LEVEL_PROGRESS_FAILURE = "GET_ELEVATE_LEVEL_PROGRESS_FAILURE";

const GET_TEST_PROGRESS = "GET_TEST_PROGRESS";
const GET_TEST_PROGRESS_SUCCESS = "GET_TEST_PROGRESS_SUCCESS";
const GET_TEST_PROGRESS_FAILURE = "GET_TEST_PROGRESS_FAILURE";

const GET_CREATE_SESSION_SERVICE = "GET_CREATE_SESSION_SERVICE";
const GET_CREATE_SESSION_SERVICE_SUCCESS = "GET_CREATE_SESSION_SERVICE_SUCCESS";
const GET_CREATE_SESSION_SERVICE_FAILURE = "GET_CREATE_SESSION_SERVICE_FAILURE";

const GET_TMS_CALENDAR_EVENT = "GET_TMS_CALENDAR_EVENT";
const GET_TMS_CALENDAR_EVENT_SUCCESS = "GET_TMS_CALENDAR_EVENT_SUCCESS";
const GET_TMS_CALENDAR_EVENT_FAILURE = "GET_TMS_CALENDAR_EVENT_FAILURE";

const GET_TMS_LEARNER_AVAILABILITY = "GET_TMS_LEARNER_AVAILABILITY";
const GET_TMS_LEARNER_AVAILABILITY_SUCCESS = "GET_TMS_LEARNER_AVAILABILITY_SUCCESS";
const GET_TMS_LEARNER_AVAILABILITY_FAILURE = "GET_TMS_LEARNER_AVAILABILITY_FAILURE";

const GET_FEEDBACK = "GET_FEEDBACK";
const GET_FEEDBACK_SUCCESS = "GET_FEEDBACK_SUCCESS";
const GET_FEEDBACK_FAILURE = "GET_FEEDBACK_FAILURE";

const GET_LEARNER_FEEDBACK_INFO = "GET_LEARNER_FEEDBACK_INFO";
const GET_LEARNER_FEEDBACK_FAILURE = "GET_LEARNER_FEEDBACK_FAILURE";
const GET_LEARNER_FEEDBACK_SUCCESS = "GET_LEARNER_FEEDBACK_SUCCESS";

const SET_RENEWAL_INTERCEPT_REQUIRED = "SET_RENEWAL_INTERCEPT_REQUIRED";

const GET_ACTIVITY_SUMMARY = "GET_ACTIVITY_SUMMARY";
const GET_ACTIVITY_SUMMARY_SUCCESS = "GET_ACTIVITY_SUMMARY_SUCCESS";
const GET_ACTIVITY_SUMMARY_FAILURE = "GET_ACTIVITY_SUMMARY_FAILURE";

const SET_NEWSFEED_COUNTRY_BLOCK = "SET_NEWSFEED_COUNTRY_BLOCK";
const GET_PRODUCT_ID = "GET_PRODUCT_ID";

const PUT_CUSTOM_FIELDS = "PUT_CUSTOM_FIELDS";
const PUT_CUSTOM_FIELDS_SUCCESS = "PUT_CUSTOM_FIELDS_SUCCESS";
const PUT_CUSTOM_FIELDS_FAILURE = "PUT_CUSTOM_FIELDS_FAILURE";
const GET_SKILL_OUTCOME_SUMMARY = "GET_SKILL_OUTCOME_SUMMARY";
const GET_SKILL_OUTCOME_SUMMARY_SUCCESS = "GET_SKILL_OUTCOME_SUMMARY_SUCCESS";
const GET_SKILL_OUTCOME_SUMMARY_FAILURE = "GET_SKILL_OUTCOME_SUMMARY_FAILURE";

const GET_SOLO_ACTIVE_COURSE_INFO = "GET_SOLO_ACTIVE_COURSE_INFO";
const GET_SOLO_ACTIVE_COURSE_SUCCESS = "GET_SOLO_ACTIVE_COURSE_SUCCESS";
const GET_SOLO_ACTIVE_COURSE_FAILURE = "GET_SOLO_ACTIVE_COURSE_FAILURE";
const GET_BADGE_URL = "GET_BADGE_URL";
const GET_IS_TMS_REQUIRED = "GET_IS_TMS_REQUIRED";

const GET_LEARNER_DETAILS = "GET_LEARNER_DETAILS";
const GET_LEARNER_DETAILS_SUCCESS = "GET_LEARNER_DETAILS_SUCCESS";
const GET_LEARNER_DETAILS_FAILURE = "GET_LEARNER_DETAILS_FAILURE";

const GET_TWT_SESSIONS = "GET_TWT_SESSIONS";
const GET_TWT_SESSIONS_SUCCESS = "GET_TWT_SESSIONS_SUCCESS";
const GET_TWT_SESSIONS_FAILURE = "GET_TWT_SESSIONS_FAILURE";

const GET_TWT_NOTIFICATIONS_SUCCESS = "GET_TWT_NOTIFICATIONS_SUCCESS";

const GET_TWT_TOKEN = "GET_TWT_TOKEN";
const GET_TWT_TOKEN_SUCCESS = "GET_TWT_TOKEN_SUCCESS";
const GET_TWT_TOKEN_FAILURE = "GET_TWT_TOKEN_FAILURE";

const TWT_USER_TRACK_HISTORY = "TWT_USER_TRACK_HISTORY";
const TWT_USER_TRACK_HISTORY_SUCCESS = "TWT_USER_TRACK_HISTORY_SUCCESS";
const TWT_USER_TRACK_HISTORY_FAILURE = "TWT_USER_TRACK_HISTORY_FAILURE";

const GET_OTHER_TASKS = "GET_OTHER_TASKS";
const GET_OTHER_TASKS_SUCCESS = "GET_OTHER_TASKS_SUCCESS";
const GET_OTHER_TASKS_FAILURE = "GET_OTHER_TASKS_FAILURE";

const SET_SELECTED_COUNTRY = "SET_SELECTED_COUNTRY";

const GET_VOCABULARY_CONTENTS = "GET_VOCABULARY_CONTENTS";
const GET_VOCABULARY_CONTENTS_SUCCESS = "GET_VOCABULARY_CONTENTS_SUCCESS";
const GET_VOCABULARY_CONTENTS_FAILURE = "GET_VOCABULARY_CONTENTS_FAILURE";

const GET_VOCABULARY_WORD_LIST = "GET_VOCABULARY_WORD_LIST";
const GET_VOCABULARY_WORD_LIST_SUCCESS = "GET_VOCABULARY_WORD_LIST_SUCCESS";
const GET_VOCABULARY_WORD_LIST_FAILURE = "GET_VOCABULARY_WORD_LIST_FAILURE";

const GET_VOCABULARY_SEARCHED_WORD = "GET_VOCABULARY_SEARCHED_WORD";
const GET_VOCABULARY_SEARCHED_WORD_SUCCESS = "GET_VOCABULARY_SEARCHED_WORD_SUCCESS";
const GET_VOCABULARY_SEARCHED_WORD_FAILURE = "GET_VOCABULARY_SEARCHED_WORD_FAILURE";

const ADMIN = "admin";
const USER = "user";

const CASE_SENSITIVE = 1;
const NON_CASE_SENSITIVE = 0;

const VOCABULARY_RESET_SEARCH_PARAMS = "VOCABULARY_RESET_SEARCH_PARAMS";

const CREATE_VOCABULARY_WORDLIST = "CREATE_VOCABULARY_WORDLIST";
const CREATE_VOCABULARY_WORDLIST_SUCCESS = "CREATE_VOCABULARY_WORDLIST_SUCCESS";
const CREATE_VOCABULARY_WORDLIST_FAILURE = "CREATE_VOCABULARY_WORDLIST_FAILURE";
const RESET_CREATED_WORDLIST_STATUS = "RESET_CREATED_WORDLIST_STATUS";

const UPDATE_VOCABULARY_WORD_NOTE = "UPDATE_VOCABULARY_WORD_NOTE";
const UPDATE_VOCABULARY_WORD_NOTE_SUCCESS = "UPDATE_VOCABULARY_WORD_NOTE_SUCCESS";
const UPDATE_VOCABULARY_WORD_NOTE_FAILURE = "UPDATE_VOCABULARY_WORD_NOTE_FAILURE";
const RESET_UPDATE_VOCABULARY_WORD_STATUS = "RESET_UPDATE_VOCABULARY_WORD_STATUS";

const VOCABULARY_ADD_WORD_TO_LIST = "VOCABULARY_ADD_WORD_TO_LIST";
const VOCABULARY_ADD_WORD_TO_LIST_SUCCESS = "VOCABULARY_ADD_WORD_TO_LIST_SUCCESS";
const VOCABULARY_ADD_WORD_TO_LIST_FAILURE = "VOCABULARY_ADD_WORD_TO_LIST_FAILURE";
const RESET_VOCABULARY_ADD_WORD_TO_LIST = "RESET_VOCABULARY_ADD_WORD_TO_LIST";

const VOCABULARY_TYPE = "listType";
const VOCABULARY_ACTION = "words";
const VOCABULARY_WORDLIST = "globalenglish";

const VOCABULARY_ADD_WORD = "VOCABULARY_ADD_WORD";
const VOCABULARY_ADD_WORD_SUCCESS = "VOCABULARY_ADD_WORD_SUCCESS";
const VOCABULARY_ADD_WORD_FAILURE = "VOCABULARY_ADD_WORD_FAILURE";
const RESET_VOCABULARY_ADD_WORD = "RESET_VOCABULARY_ADD_WORD";

const VOCABULARY_DELETE_WORDLIST = "VOCABULARY_DELETE_WORDLIST";
const VOCABULARY_DELETE_WORDLIST_SUCCESS = "VOCABULARY_DELETE_WORDLIST_SUCCESS";
const VOCABULARY_DELETE_WORDLIST_FAILURE = "VOCABULARY_DELETE_WORDLIST_FAILURE";
const RESET_VOCABULARY_DELETE_WORDLIST = "RESET_VOCABULARY_DELETE_WORDLIST";

const VOCABULARY_DELETE_WORD = "VOCABULARY_DELETE_WORD";
const VOCABULARY_DELETE_WORD_SUCCESS = "VOCABULARY_DELETE_WORD_SUCCESS";
const VOCABULARY_DELETE_WORD_FAILURE = "VOCABULARY_DELETE_WORD_FAILURE";
const RESET_VOCABULARY_DELETE_WORD = "RESET_VOCABULARY_DELETE_WORD";

const VOCABULARY_UPDATE_WORD_LIST = "VOCABULARY_UPDATE_WORD_LIST";
const VOCABULARY_UPDATE_WORD_LIST_SUCCESS = "VOCABULARY_UPDATE_WORD_LIST_SUCCESS";
const VOCABULARY_UPDATE_WORD_LIST_FAILURE = "VOCABULARY_UPDATE_WORD_LIST_FAILURE";
const RESET_VOCABULARY_UPDATE_WORD_LIST = "RESET_VOCABULARY_UPDATE_WORD_LIST";

const GET_LEARNER_PROGRESS = "GET_LEARNER_PROGRESS";
const GET_LEARNER_PROGRESS_SUCCESS = "GET_LEARNER_PROGRESS_SUCCESS";
const GET_LEARNER_PROGRESS_FAILURE = "GET_LEARNER_PROGRESS_FAILURE";

const GET_CULTURE_CENTRE_COUNTRIES = "GET_CULTURE_CENTRE_COUNTRIES";
const GET_CULTURE_CENTRE_COUNTRIES_SUCCESS = "GET_CULTURE_CENTRE_COUNTRIES_SUCCESS";
const GET_CULTURE_CENTRE_COUNTRIES_FAILURE = "GET_CULTURE_CENTRE_COUNTRIES_FAILURE";

const GET_LEARNER_NEW_PROGRESS = "GET_LEARNER_NEW_PROGRESS";
const GET_LEARNER_NEW_PROGRESS_SUCCESS = "GET_LEARNER_NEW_PROGRESS_SUCCESS";
const GET_LEARNER_NEW_PROGRESS_FAILURE = "GET_LEARNER_NEW_PROGRESS_FAILURE";

export {
  SET_INITIAL_USER_INFO,
  SET_PUBLIC_KEY,
  SET_SELECTED_LANGUAGE,
  SET_MANAGER_EMAIL,
  SET_MANAGER_EMAIL_REQUIRED,
  SET_USER_AUTHENTICATED,
  SET_USER_AUTHENTICATION_START,
  SET_USER_AUTHENTICATION_FAIL_REASON,
  GET_PEOPLE_INFO,
  GET_PEOPLE_INFO_SUCCESS,
  GET_PEOPLE_INFO_FAILURE,
  GET_LEARNER_TASKS,
  GET_LEARNER_TASKS_SUCCESS,
  GET_LEARNER_TASKS_FAILURE,
  GET_PORTAL_LOGIN,
  GET_PORTAL_LOGIN_SUCCESS,
  GET_PORTAL_LOGIN_FAILURE,
  GET_LEARNER_JWTOKEN,
  GET_LEARNER_JWTOKEN_SUCCESS,
  GET_LEARNER_JWTOKEN_FAILURE,
  GET_NEWSFEED_API,
  GET_NEWSFEED_API_SUCCESS,
  GET_NEWSFEED_API_FAILURE,
  GET_WELCOMEFLOW_API,
  GET_WELCOMEFLOW_API_SUCCESS,
  GET_WELCOMEFLOW_API_FAILURE,
  GET_TMS_COURSES,
  GET_TMS_COURSES_SUCCESS,
  GET_TMS_COURSES_FAILURE,
  GET_ELEVATE_ASSESSMENT_DETAILS,
  GET_ELEVATE_ASSESSMENT_DETAILS_SUCCESS,
  GET_ELEVATE_ASSESSMENT_DETAILS_FAILURE,
  GET_ELEVATE_TEST_RESULT,
  GET_ELEVATE_TEST_RESULT_SUCCESS,
  GET_ELEVATE_TEST_RESULT_FAILURE,
  GET_TMS_LOGIN,
  GET_TMS_LOGIN_SUCCESS,
  GET_TMS_LOGIN_FAILURE,
  GET_TMS_LOGOUT,
  GET_TMS_LOGOUT_SUCCESS,
  GET_TMS_LOGOUT_FAILURE,
  STOP_TMS_API_PROPAGATION,
  GET_ANNOUNCEMENTS,
  GET_ANNOUNCEMENTS_SUCCESS,
  GET_ANNOUNCEMENTS_FAILURE,
  GET_JWK_PUBLIC_KEY,
  GET_JWK_PUBLIC_KEY_SUCCESS,
  GET_JWK_PUBLIC_KEY_FAILURE,
  DESTROY_SESSION,
  TRIGGER_TOAST,
  RESET_TOAST,
  GET_RENEWAL_INFO,
  GET_RENEWAL_INFO_SUCCESS,
  GET_RENEWAL_INFO_FAILURE,
  GET_ACTIVE_COURSE_INFO,
  GET_ACTIVE_COURSE_SUCCESS,
  GET_ACTIVE_COURSE_FAILURE,
  GET_TMS_ASSIGNMENTS_INFO,
  GET_TMS_ASSISGNMENTS_SUCCESS,
  GET_TMS_ASSISGNMENTS_FAILURE,
  GET_HANDOUTS_INFO,
  GET_HANDOUTS_SUCCESS,
  GET_HANDOUTS_FAILURE,
  GET_HOMEWORKS_INFO,
  GET_HOMEWORKS_SUCCESS,
  GET_HOMEWORKS_FAILURE,
  GET_TMS_LEARNER_SESSION_INFO,
  GET_TMS_LEARNER_SESSION_SUCCESS,
  GET_TMS_LEARNER_SESSION_FAILURE,
  GET_CITIES_LIST,
  GET_CITIES_LIST_SUCCESS,
  GET_CITIES_LIST_FAILURE,
  GET_COUNTRIES_LIST,
  GET_COUNTRIES_LIST_SUCCESS,
  GET_COUNTRIES_LIST_FAILURE,
  GET_STATES_LIST,
  GET_STATES_LIST_SUCCESS,
  GET_STATES_LIST_FAILURE,
  GET_CUSTOM_FIELDS,
  GET_CUSTOM_FIELDS_SUCCESS,
  GET_CUSTOM_FIELDS_FAILURE,
  SET_CUSTOM_FIELDS,
  SET_CUSTOM_FIELDS_SUCCESS,
  SET_CUSTOM_FIELDS_FAILURE,
  SEND_OTP,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILURE,
  UPDATE_TIMEZONE,
  UPDATE_TIMEZONE_SUCCESS,
  UPDATE_TIMEZONE_FAILURE,
  RESET_TIMEZONE_STATE,
  SET_PEOPLE_INFO,
  SET_PEOPLE_INFO_SUCCESS,
  SET_PEOPLE_INFO_FAILURE,
  SET_PEOPLE_INFO_RESET,
  SET_LEARNER_TASKS,
  SET_LEARNER_TASKS_SUCCESS,
  SET_LEARNER_TASKS_FAILURE,
  UPDATE_LEARNER_TASKS,
  UPDATE_LEARNER_TASKS_SUCCESS,
  UPDATE_LEARNER_TASKS_FAILURE,
  CLEAR_INTERMEDIATE_LEARNER_TASKS,
  UPDATE_PASSWORD_PEOPLE,
  UPDATE_PASSWORD_PEOPLE_SUCCESS,
  UPDATE_PASSWORD_PEOPLE_FAILURE,
  UPDATE_NEW_PASSWORD_PEOPLE,
  UPDATE_NEW_PASSWORD_PEOPLE_SUCCESS,
  UPDATE_NEW_PASSWORD_PEOPLE_FAILURE,
  GET_SKILLS_PROGRESS,
  GET_SKILLS_PROGRESS_SUCCESS,
  GET_SKILLS_PROGRESS_FAILURE,
  GET_REACH_PROGRESS,
  GET_REACH_PROGRESS_SUCCESS,
  GET_REACH_PROGRESS_FAILURE,
  GET_ELEVATE_LEVEL_PROGRESS,
  GET_ELEVATE_LEVEL_PROGRESS_SUCCESS,
  GET_ELEVATE_LEVEL_PROGRESS_FAILURE,
  GET_TEST_PROGRESS,
  GET_TEST_PROGRESS_SUCCESS,
  GET_TEST_PROGRESS_FAILURE,
  GET_LEARNER_FEEDBACK_INFO,
  GET_LEARNER_FEEDBACK_FAILURE,
  GET_LEARNER_FEEDBACK_SUCCESS,
  GET_CREATE_SESSION_SERVICE,
  GET_CREATE_SESSION_SERVICE_SUCCESS,
  GET_CREATE_SESSION_SERVICE_FAILURE,
  GET_TMS_CALENDAR_EVENT,
  GET_TMS_CALENDAR_EVENT_SUCCESS,
  GET_TMS_CALENDAR_EVENT_FAILURE,
  GET_TMS_LEARNER_AVAILABILITY,
  GET_TMS_LEARNER_AVAILABILITY_SUCCESS,
  GET_TMS_LEARNER_AVAILABILITY_FAILURE,
  GET_FEEDBACK,
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_FAILURE,
  SET_RENEWAL_INTERCEPT_REQUIRED,
  GET_ACTIVITY_SUMMARY,
  GET_ACTIVITY_SUMMARY_SUCCESS,
  GET_ACTIVITY_SUMMARY_FAILURE,
  SET_NEWSFEED_COUNTRY_BLOCK,
  GET_PRODUCT_ID,
  PUT_CUSTOM_FIELDS,
  PUT_CUSTOM_FIELDS_FAILURE,
  PUT_CUSTOM_FIELDS_SUCCESS,
  GET_SKILL_OUTCOME_SUMMARY,
  GET_SKILL_OUTCOME_SUMMARY_SUCCESS,
  GET_SKILL_OUTCOME_SUMMARY_FAILURE,
  GET_BADGE_URL,
  GET_SOLO_ACTIVE_COURSE_INFO,
  GET_SOLO_ACTIVE_COURSE_FAILURE,
  GET_SOLO_ACTIVE_COURSE_SUCCESS,
  GET_IS_TMS_REQUIRED,
  GET_LEARNER_DETAILS,
  GET_LEARNER_DETAILS_SUCCESS,
  GET_LEARNER_DETAILS_FAILURE,
  GET_TWT_SESSIONS,
  GET_TWT_SESSIONS_SUCCESS,
  GET_TWT_SESSIONS_FAILURE,
  GET_TWT_TOKEN,
  GET_TWT_TOKEN_SUCCESS,
  GET_TWT_TOKEN_FAILURE,
  TWT_USER_TRACK_HISTORY,
  TWT_USER_TRACK_HISTORY_SUCCESS,
  TWT_USER_TRACK_HISTORY_FAILURE,
  GET_TWT_NOTIFICATIONS_SUCCESS,
  GET_OTHER_TASKS,
  GET_OTHER_TASKS_FAILURE,
  GET_OTHER_TASKS_SUCCESS,
  SET_SELECTED_COUNTRY,
  GET_VOCABULARY_CONTENTS,
  GET_VOCABULARY_CONTENTS_SUCCESS,
  GET_VOCABULARY_CONTENTS_FAILURE,
  GET_VOCABULARY_WORD_LIST,
  GET_VOCABULARY_WORD_LIST_SUCCESS,
  GET_VOCABULARY_WORD_LIST_FAILURE,
  GET_VOCABULARY_SEARCHED_WORD,
  GET_VOCABULARY_SEARCHED_WORD_SUCCESS,
  GET_VOCABULARY_SEARCHED_WORD_FAILURE,
  ADMIN,
  USER,
  CASE_SENSITIVE,
  NON_CASE_SENSITIVE,
  VOCABULARY_RESET_SEARCH_PARAMS,
  CREATE_VOCABULARY_WORDLIST,
  CREATE_VOCABULARY_WORDLIST_SUCCESS,
  CREATE_VOCABULARY_WORDLIST_FAILURE,
  RESET_CREATED_WORDLIST_STATUS,
  UPDATE_VOCABULARY_WORD_NOTE,
  UPDATE_VOCABULARY_WORD_NOTE_SUCCESS,
  UPDATE_VOCABULARY_WORD_NOTE_FAILURE,
  RESET_UPDATE_VOCABULARY_WORD_STATUS,
  VOCABULARY_ADD_WORD_TO_LIST,
  VOCABULARY_ADD_WORD_TO_LIST_SUCCESS,
  VOCABULARY_ADD_WORD_TO_LIST_FAILURE,
  RESET_VOCABULARY_ADD_WORD_TO_LIST,
  VOCABULARY_TYPE,
  VOCABULARY_ACTION,
  VOCABULARY_WORDLIST,
  VOCABULARY_ADD_WORD,
  VOCABULARY_ADD_WORD_SUCCESS,
  VOCABULARY_ADD_WORD_FAILURE,
  RESET_VOCABULARY_ADD_WORD,
  VOCABULARY_DELETE_WORDLIST,
  VOCABULARY_DELETE_WORDLIST_SUCCESS,
  VOCABULARY_DELETE_WORDLIST_FAILURE,
  RESET_VOCABULARY_DELETE_WORDLIST,
  VOCABULARY_DELETE_WORD,
  VOCABULARY_DELETE_WORD_SUCCESS,
  VOCABULARY_DELETE_WORD_FAILURE,
  RESET_VOCABULARY_DELETE_WORD,
  VOCABULARY_UPDATE_WORD_LIST,
  VOCABULARY_UPDATE_WORD_LIST_SUCCESS,
  VOCABULARY_UPDATE_WORD_LIST_FAILURE,
  RESET_VOCABULARY_UPDATE_WORD_LIST,
  GET_LEARNER_PROGRESS,
  GET_LEARNER_PROGRESS_SUCCESS,
  GET_LEARNER_PROGRESS_FAILURE,
  GET_CULTURE_CENTRE_COUNTRIES,
  GET_CULTURE_CENTRE_COUNTRIES_SUCCESS,
  GET_CULTURE_CENTRE_COUNTRIES_FAILURE,
  GET_LEARNER_NEW_PROGRESS,
  GET_LEARNER_NEW_PROGRESS_SUCCESS,
  GET_LEARNER_NEW_PROGRESS_FAILURE,
};
